import { __assign } from 'tslib';
import React, { useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useFocus } from '@alfalab/hooks';
import { WorldMagnifierMIcon } from '@alfalab/icons-glyph/WorldMagnifierMIcon';
import { FlagIcon } from '../flag-icon/component.js';
import '../flag-icon/flagSprite.js';

var styles = {"component":"international-phone-input__component_16lez","flagIconContainer":"international-phone-input__flagIconContainer_16lez","emptyCountryIcon":"international-phone-input__emptyCountryIcon_16lez","disabled":"international-phone-input__disabled_16lez","inner":"international-phone-input__inner_16lez","size-64":"international-phone-input__size-64_16lez","size-72":"international-phone-input__size-72_16lez","focusVisible":"international-phone-input__focusVisible_16lez"};
require('./index.css');

var EMPTY_COUNTRY_SELECT_FIELD = {
    value: 'EMPTY_COUNTRY_SELECT_VALUE',
    key: 'EMPTY_COUNTRY_SELECT_KEY',
};
var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-48',
    m: 'size-56',
    l: 'size-64',
    xl: 'size-72',
    48: 'size-48',
    56: 'size-56',
    64: 'size-64',
    72: 'size-72',
};
var SelectField = function (_a) {
    var _b;
    var selected = _a.selected, Arrow = _a.Arrow, size = _a.size, disabled = _a.disabled, _c = _a.innerProps, innerProps = _c === void 0 ? {} : _c;
    var wrapperRef = useRef(null);
    var focusVisible = useFocus(wrapperRef, 'keyboard')[0];
    var ref = innerProps.ref ? mergeRefs([innerProps.ref, wrapperRef]) : wrapperRef;
    return (React.createElement("div", { ref: ref, className: cn(styles.component, size && styles[SIZE_TO_CLASSNAME_MAP[size]], (_b = {},
            _b[styles.focusVisible] = focusVisible,
            _b[styles.disabled] = disabled,
            _b)) },
        React.createElement("div", __assign({}, innerProps, { className: styles.inner }),
            React.createElement("span", { className: styles.flagIconContainer }, !selected || selected === EMPTY_COUNTRY_SELECT_FIELD ? (React.createElement(WorldMagnifierMIcon, { className: styles.emptyCountryIcon })) : (React.createElement(FlagIcon, { country: selected.key }))),
            Arrow)));
};

export { EMPTY_COUNTRY_SELECT_FIELD, SelectField };
